import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getProxyUserList } from 'src/pages/more/pages/proxies/redux/action/index.js';
import AutoComplete from '../../../../../common/refactoredComponents/form/autocomplete/AutoComplete';
import { Line1 } from './index.styled';
import { useTranslation } from 'react-i18next';
import { getAdminProxyUsers } from 'src/pages/admin/redux/action';
import { DropDownContainer, EmployeeName, EmployeeRole } from './PaginatedAutocomplete.styled';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const PAGE_SIZE = 100;

const PaginatedAutocomplete = ({ setIsOption=()=>{}, isOption=false, handleChange = () => { }, districtType = '', isProxyFor = false, props, setApply = () => { }, isAdminScreen = false, id = '', setIsProxyForOption=()=>{}, isProxyForOption=false }) => {
  const [inputValue, setInputValue] = useState('');
  const [inputValueProxyFor, setInputValueProxyFor] = useState('');
  const [options, setOptions] = useState([]);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedValueProxyFor, setSelectedValueProxyFor] = useState(null);
  const [prevInputValue, setPrevInputValue] = useState('');
  const [prevInputValueProxyFor, setPrevInputValueProxyFor] = useState('');
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const proxyUserList = useSelector((state) => isAdminScreen ? state.AdminProxyReducer.proxyUserList.userList : state.ProxyReducer.proxyUserList.userList);
  const proxyUserListLoading = useSelector((state) => isAdminScreen ? state.AdminProxyReducer.proxyUserListLoading : state.ProxyReducer.proxyUserListLoading);
  const [optionForProxyFor, setOptionForProxyFor] = useState([]);

  // Clear selected values when districtType changes
  useEffectWithErrorLogging(() => {
    setSelectedValue(null);
    setSelectedValueProxyFor(null);
    setOptions([]);
    setOptionForProxyFor([]);
    setPage(0);
    setHasMore(true);
    setIsOption(true);
    setIsProxyForOption(true);
    
  }, [districtType]);
  // Initial fetch for first 100 users, reset options only when search term changes
  useEffectWithErrorLogging(() => {
    if (inputValue !== prevInputValue) {
      setIsOption(true);
      setOptions([]);
      setPage(0);
      setPrevInputValue(inputValue);
      setHasMore(true);
      if (isAdminScreen) {
        dispatch(getAdminProxyUsers({ networkIdName: props.addProxyData.networkIdName, isOutsideDistrict: districtType === 'outside' ? true : false, page: 0, pageSize: PAGE_SIZE, searchTerm: inputValue }));
      } else {
        dispatch(getProxyUserList({ isOutsideDistrict: districtType === 'outside' ? true : false, page: 0, pageSize: PAGE_SIZE, searchTerm: inputValue }));
      }
    }
    if (inputValueProxyFor !== prevInputValueProxyFor) {
      setIsProxyForOption(true);
      setOptionForProxyFor([]);
      setPage(0);
      setPrevInputValueProxyFor(inputValueProxyFor);
      setHasMore(true);
      if (isAdminScreen) {
        dispatch(getAdminProxyUsers({ networkIdName: props.addProxyData.networkIdName, isOutsideDistrict: districtType === 'outside' ? true : false, page: 0, pageSize: PAGE_SIZE, searchTerm: inputValueProxyFor }));
      } else {
        dispatch(getProxyUserList({ isOutsideDistrict: districtType === 'outside' ? true : false, page: 0, pageSize: PAGE_SIZE, searchTerm: inputValueProxyFor }));
      }
    }
  }, [inputValue, inputValueProxyFor, dispatch, isAdminScreen, districtType, prevInputValue, prevInputValueProxyFor]);

  // Accumulate options when proxyUserList changes (append new page results)
  useEffectWithErrorLogging(() => {
    if (proxyUserList && proxyUserList.length > 0) {
      if(isProxyForOption) {
        setIsProxyForOption(false);
        setOptionForProxyFor((prev) => {
        if (page === 0) {
          // For first page, replace options
          return proxyUserList;
        } else {
          // For subsequent pages, append new options
          const existingUids = new Set(prev.map(opt => opt.uid));
          const newOptions = proxyUserList.filter(opt => !existingUids.has(opt.uid));
          return [...prev, ...newOptions];
        }
      });}
      if(isOption){
        setIsOption(false);
        setOptions((prev) => {
        if (page === 0) {
          // For first page, replace options
          return proxyUserList;
        } else {
          // For subsequent pages, append new options
          const existingUids = new Set(prev.map(opt => opt.uid));
          const newOptions = proxyUserList.filter(opt => !existingUids.has(opt.uid));
          return [...prev, ...newOptions];
        }
      });}
      setHasMore(proxyUserList.length >= PAGE_SIZE);
    }
  }, [proxyUserList, page]);

  const UserListTemplate = (option) => (
    <DropDownContainer>
      <EmployeeName>
        <span className="more-person-name-dt-mask">{option.displayName}</span>
      </EmployeeName>
      <EmployeeRole>
        {option.employeeRole}
      </EmployeeRole>
      <Line1 />
    </DropDownContainer>
  );

  const handleScroll = async (event) => {
    const listboxNode = event.currentTarget;
    const bottomReached = listboxNode.scrollTop + listboxNode.clientHeight >= listboxNode.scrollHeight - 10;
    if (bottomReached && !proxyUserListLoading && !loading && hasMore) {
      setLoading(true);
      // Fetch next page of users
      const nextPage = page + 1;
      const searchTerm = isProxyFor ? inputValueProxyFor : inputValue;
      isProxyFor ? setIsProxyForOption(true) : setIsOption(true);
      if (isAdminScreen) {
        dispatch(getAdminProxyUsers({ networkIdName: props.addProxyData.networkIdName, isOutsideDistrict: districtType === 'outside' ? true : false, page: nextPage, pageSize: PAGE_SIZE, searchTerm: searchTerm }));
      } else {
        dispatch(getProxyUserList({ isOutsideDistrict: districtType === 'outside' ? true : false, page: nextPage, pageSize: PAGE_SIZE, searchTerm: searchTerm }));
      }
      setPage(nextPage);
      setLoading(false);
    }
  };

  return (
    <>
      <AutoComplete
        id={id}
        placeholder={t('proxies.addAProxy.selectOrSearchaUser')}
        showScrollBar={true}
        isFullWidth={true}
        boxShadow="0px 3px 6px #00000029"
        disableClearable={false}
        options={isProxyFor ? optionForProxyFor : options}
        loading={proxyUserListLoading || loading}
        field="displayName"
        optionValue="uid"
        value={isProxyFor ? selectedValueProxyFor : selectedValue}
        zIndex={9999999}
        inputValue={isProxyFor ? inputValueProxyFor : inputValue}
        onChange={(value, reason) => {
          if (reason === 'clear') {
            setApply(false);
            if (isProxyFor) {
              setSelectedValueProxyFor(null);
            } else {
              setSelectedValue(null);
            }
          } else {
            isProxyFor ? setSelectedValueProxyFor(value) : setSelectedValue(value);
            setLoading(false);
            value.uid !== '' && handleChange(value);
          }
        }}
        onInputChange={(event, value) => {
          !isProxyFor ? setInputValue(value) : setInputValueProxyFor(value);
        }}
        listBoxProps={{
          onScroll: handleScroll,
          style: { maxHeight: 300, overflow: 'auto' },
        }}
        itemTemplate={(option) => UserListTemplate(option, 'userList')}
        isAddProxy={true}
        readOnly={isProxyFor ? selectedValueProxyFor : selectedValue}
      />
    </>
  );
};


export default PaginatedAutocomplete;